import React from 'react'
import { createStyles, Checkbox, makeStyles } from '@material-ui/core'
import { Typography as FoundationsTypography } from 'foundations-library/components'
import { CheckboxOutlineBlankIcon, CheckboxIcon, IndeterminateCheckboxIcon } from 'svg-icons'

const useStyles = makeStyles(() =>
    createStyles({
        termsAndConditions: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
            alignSelf: 'stretch',
            '& label': {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '5px',
                cursor: 'pointer'
            },
            '& a': {
                color: 'inherit',
                textDecoration: 'underline'
            }
        }
    })
)

interface Props {
    disabled: boolean;

    agreeWithSubscription: boolean;
    setAgreeWithSubscription: (agreeWithSubscription: boolean) => void;

    receiveSMS: boolean;
    setReceiveSMS: (receiveSMS: boolean) => void;

    receiveSMSOffers: boolean;
    setReceiveSMSOffers: (setReceiveSMSOffers: boolean) => void;
}

/**
 * Checkout step of sign-up
 */
const TermsAndConditions = (props: Props) : JSX.Element => {
    const classes = useStyles()

    return (
        <div className={classes.termsAndConditions}>
            <FoundationsTypography variant='body4' color='neutral-400'>
                By clicking &quot;Create your account&quot;, you agree to the <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms of Service</a> and <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>. You&apos;ll receive promotional emails, including product updates, special offers and best practices, unless you choose to opt-out.
            </FoundationsTypography>

            <label>
                <Checkbox
                    data-testid="subscription_consent"
                    disableRipple
                    size='small'
                    color="primary"
                    icon = {<CheckboxOutlineBlankIcon/>}
                    checkedIcon = {<CheckboxIcon/>}
                    indeterminateIcon = {<IndeterminateCheckboxIcon/>}
                    disabled={props.disabled}
                    checked={props.agreeWithSubscription}
                    onChange={e => props.setAgreeWithSubscription(e.target.checked)}
                />

                <FoundationsTypography variant='body4' color='neutral-400'>
                    I agree that my subscription will automatically renew at the
                    subscription fee for my selected term length until I cancel.
                    I can cancel anytime by visiting Pay my Bill. Prices subject to change.
                </FoundationsTypography>
            </label>

            <label>
                <Checkbox
                    data-testid="receive_sms"
                    disableRipple
                    size='small'
                    color="primary"
                    icon = {<CheckboxOutlineBlankIcon/>}
                    checkedIcon = {<CheckboxIcon/>}
                    indeterminateIcon = {<IndeterminateCheckboxIcon/>}
                    disabled={props.disabled}
                    checked={props.receiveSMS}
                    onChange={e => props.setReceiveSMS(e.target.checked)}
                />

                <FoundationsTypography variant='body4' color='neutral-400'>
                    I consent to receive critical text messages pertaining to my service.
                </FoundationsTypography>
            </label>

            <label>
                <Checkbox
                    data-testid="receive_sms_offers"
                    disableRipple
                    size='small'
                    color="primary"
                    icon = {<CheckboxOutlineBlankIcon/>}
                    checkedIcon = {<CheckboxIcon/>}
                    indeterminateIcon = {<IndeterminateCheckboxIcon/>}
                    disabled={props.disabled}
                    checked={props.receiveSMSOffers}
                    onChange={e => props.setReceiveSMSOffers(e.target.checked)}
                />

                <FoundationsTypography variant='body4' color='neutral-400'>
                    I consent to receive text messages with special offers.
                </FoundationsTypography>
            </label>
        </div>
    )
}

export default TermsAndConditions
